module.exports = __webpack_public_path__ + "img/KevinSharonCare.be08bf94.jpg";